import { render, staticRenderFns } from "./DeliveryFilter.vue?vue&type=template&id=4b019638"
import script from "./DeliveryFilter.vue?vue&type=script&lang=js"
export * from "./DeliveryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports